import NavBar from "../Components/NavBar";
import "../CSS/reporte.css";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { db } from "../FirebaseConfig/firebase";
import Button from "@mui/material/Button";

import { CSVLink } from "react-csv";

function MisEntradas() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [codigosList, setCodigosList] = useState([]);
  const [datosCargados, setDatosCargados] = useState(false); // MOSTRAR BARRA DE CARGA

  function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
  }

  //FOR DE FORS
  const buscarCodigos = async () => {
    const cuponesList = collection(
      db,
      `USUARIOS/${localStorage.getItem("idDocumento")}/AsientosRegistrados`
    );
    const data = await getDocs(cuponesList);
    setCodigosList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
	setDatosCargados(true);

  };

  //cerrar cupones
  const cerrar = () => {
    navigate(`../panelUser/`);
  };
  useEffect(() => {
    buscarCodigos();
  }, []);
  useEffect(() => {
  }, [codigosList]);
  if (!datosCargados) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px auto",
          textAlign: "center",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ verticalAlign: "middle", display: "block" }}>
          <div>
            <img
              style={{ height: "300px" }}
              src={require(`../img/docucargando.gif`)}
              alt="esperando"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="panel">
      <NavBar
        titulo="Mis Entradas"
        nombre=""
        imagen="cerrar"
        logoTitulo="cupon"
        cerrar={cerrar}
      ></NavBar>
      <div className="reporte-cabecera">
        <h1 className="cd">Total de eventos : {codigosList.length}</h1>
      </div>
     

      <div className="reporte-tabla">
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  <b>EVENTO</b>
                </TableCell>
                <TableCell align="center">
                  <b>ASIENTOS COMPRADOS</b>
                </TableCell>
                <TableCell align="center">
                  <b>ESTADO DE PAGO</b>
                </TableCell>
                <TableCell align="center">
                  <b>FECHA DE COMPRA</b>
                </TableCell>
                <TableCell align="center">
                  <b>TICKET</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {codigosList.map((row) => (
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">{row.evento}</TableCell>
                  <TableCell align="center">{row.asientos}</TableCell>
                  <TableCell align="center">{row.estado}</TableCell>
                  <TableCell align="center">{row.fecha}</TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      color="success"
                      onClick={()=>{navigate(
                        `/eventos/${row.idEvento}/registrarParticipante/${row.idEntrada}`
                      )}}
                    >
                      Ver Entrada
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default MisEntradas;
